import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import {
  contentStatsFetchStateConfig,
  courseStatsFetchStateConfig,
  sectionStatsFetchStateConfig,
  userStatsFetchStateConfig
} from "../consts";

export const { fetchActionFactory: fetchUserStatActionFactory } =
  makeCrudStateActionFactories(userStatsFetchStateConfig);

export const {
  fetchActionFactory: fetchCourseStatActionFactory,
  fetchAllActionFactory: fetchAllCourseStatsActionFactory
} = makeCrudStateActionFactories(courseStatsFetchStateConfig);

export const { fetchActionFactory: fetchSectionStatActionFactory } =
  makeCrudStateActionFactories(sectionStatsFetchStateConfig);

export const { fetchActionFactory: fetchContentStatsActionFactory } =
  makeCrudStateActionFactories(contentStatsFetchStateConfig);
